"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_TRANSITION_DURATION_MS = exports.NONE_TRANSITION = void 0;
const DEFAULT_TRANSITION_DURATION_MS = 500;
exports.DEFAULT_TRANSITION_DURATION_MS = DEFAULT_TRANSITION_DURATION_MS;
const NONE_TRANSITION = {
    name: 'None',
    get inSceneAnimation() {
        return { name: 'none' };
    },
    get outSceneAnimation() {
        return { name: 'none' };
    },
};
exports.NONE_TRANSITION = NONE_TRANSITION;
const defaultAvailableSceneTransitions = [
    {
        name: 'Fade',
        get inSceneAnimation() {
            return undefined;
        },
        get outSceneAnimation() {
            return { name: 'fadeOut', opacity: [1, 0], duration: DEFAULT_TRANSITION_DURATION_MS, easing: 'linear' };
        },
    },
    NONE_TRANSITION,
];
exports.default = defaultAvailableSceneTransitions;
